import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstancePublic } from "../../utils";
import {
  getLoggedStatus,
  getLoggedUser,
  getStoredToken,
  removeLoggedStatus,
  removeLoggedUser,
  removeToken,
  storeLoggedStatus,
  storeLoggedUser,
  storeToken,
} from "../../utils/_localStorage";
import { startLoading, stopLoading } from "./_uiReducer";

const initialState = {
  loggedUser: getLoggedUser(),
  loggedIn: getLoggedStatus(),
  token: getStoredToken(),
};

export const doLogin = createAsyncThunk(
  "session/login",
  async (params, { dispatch }) => {
    try {
      const { email = null, password = null } = params || {};
      dispatch(startLoading());
      const { data = null } = await apiInstancePublic.post(
        "/autenticacao/login",
        {
          email,
          password,
        }
      );
      dispatch(stopLoading());
      return data;
    } catch (err) {
      dispatch(stopLoading());
      return null;
    }
  }
);

const sessionContext = createSlice({
  name: "sessionContext",
  initialState,
  reducers: {
    doLogout: (state) => {
      removeLoggedStatus();
      removeLoggedUser();
      removeToken();
      state.loggedIn = false;
      state.loggedUser = null;
      state.token = null;
    },

    loginWithToken: (state, action) => {
      const { user, token } = action.payload;

      storeLoggedStatus(true);
      storeLoggedUser(JSON.stringify(user));
      storeToken(token);

      state.loggedIn = true;
      state.loggedUser = user;
      state.token = token;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doLogin.fulfilled, (state, action) => {
      const { auth = false, user = null, token = null } = action?.payload || {};

      storeLoggedStatus(auth);
      storeLoggedUser(JSON.stringify(user));
      storeToken(token);

      state.loggedUser = user;
      state.loggedIn = auth;
      state.token = token;
    });
  },
});

export const { doLogout, loginWithToken } = sessionContext.actions;

export default sessionContext.reducer;
